import { render, staticRenderFns } from "./TimesheetComments.vue?vue&type=template&id=5a70e9f3&"
import script from "./TimesheetComments.vue?vue&type=script&lang=js&"
export * from "./TimesheetComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports